<div class="filter-bar">
  <div class="filter-types" role="group" aria-label="Filtrar por">
    <span class="filter-title">Filtrar por</span>
    <div class="filter-chips">
      <button
        type="button"
        class="filter-chip"
        [class.is-active]="filterMode() === FILTER_MODE.LOAD_ID"
        (click)="filterModeChange.emit(FILTER_MODE.LOAD_ID)"
        [attr.aria-pressed]="filterMode() === FILTER_MODE.LOAD_ID"
      >
        <i class="pi pi-hashtag"></i>
        ID de carga
      </button>
      <button
        type="button"
        class="filter-chip"
        [class.is-active]="filterMode() === FILTER_MODE.POLICY"
        (click)="filterModeChange.emit(FILTER_MODE.POLICY)"
        [attr.aria-pressed]="filterMode() === FILTER_MODE.POLICY"
      >
        <i class="pi pi-file"></i>
        N° Póliza
      </button>
    </div>
  </div>
  <div class="filter-search">
    <div class="filter-field">
      <i class="pi pi-search filter-icon"></i>
      <input
        type="text"
        class="filter-input"
        [placeholder]="
          filterMode() === FILTER_MODE.POLICY
            ? 'Buscar por N° Póliza'
            : 'Buscar por ID de carga'
        "
        [formControl]="filterControl"
        autocomplete="off"
        (keydown.enter)="onSearch()"
        (blur)="onSearch()"
      />
      @if (showFilterError) {
        <div class="filter-error">
          <i class="pi pi-exclamation-circle"></i>
          @if (hasPolicyPatternError) {
            <span>{{ 'policyNumberOnlyNumbers' | translate }}</span>
          } @else if (hasPolicyLengthError) {
            <span>{{ 'policyNumberExactLength' | translate }}</span>
          } @else if (hasLoadIdPatternError) {
            <span>{{ 'loadIdInvalidFormat' | translate }}</span>
          }
        </div>
      }
      @if (filterText()) {
        <button
          class="filter-clear"
          (click)="filterTextChange.emit('')"
          title="Limpiar filtro"
        >
          <i class="pi pi-times"></i>
        </button>
      }
    </div>
  </div>
  <div class="filter-actions">
    <button
      type="button"
      class="reset-btn"
      (click)="refresh.emit()"
      [disabled]="isRefreshing() || isLoading()"
      title="Actualizar tabla"
    >
      <i class="pi pi-refresh" [class.spin]="isRefreshing()"></i>
      <span class="refresh-btn__label">
        {{ isRefreshing() ? 'Actualizando...' : 'Actualizar' }}
      </span>
    </button>
    <button
      type="button"
      class="reset-btn"
      (click)="reset.emit()"
      [disabled]="isRefreshing() || isLoading() || !filterText().trim()"
      title="Volver a consulta por DNI"
    >
      <i class="pi pi-filter-slash"></i>
      Eliminar filtros
    </button>
  </div>
</div>
